import { Grid } from '@mui/material';
import { FraudModeDataProps } from './props';
import { useFraudModeData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const FraudModeData = (props: FraudModeDataProps) => {
    const { formik, typesPqr } = useFraudModeData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Código"
                    name="valueSmart"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.valueSmart}
                    errors={formik.errors.valueSmart}
                    value={formik.values.valueSmart}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesPqr)}
                    name="parent"
                    label="Tipo de Pqr"
                    size="small"
                    touched={formik.touched.parent}
                    errors={formik.errors.parent}
                    value={formik.values.parent}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('parent', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.extra}
                    errors={formik.errors.extra}
                    value={formik.values.extra}
                    onChange={formik.handleChange}
                    required={!!props?.data?.id}
                />
            </Grid>
        </Grid>
    );
};
